import { lazy } from 'react';

export const TariffsPageLazy = lazy(() => import('./TariffsPage'));
